function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#F64B39",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59 49V27C59 23 62 20 66 20H108C112 20 115 23 115 27V135"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 135V55C43 51 46 48 50 48H100C104 48 107 51 107 55V135"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115 99H125V135"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 136H137"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 135V113C68 109 71 106 75 106C79 106 82 109 82 113V135"
}), /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 64,
  width: 8,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 64,
  width: 8,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 57,
  y: 85,
  width: 8,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 85,
  width: 8,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 32,
  width: 7,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 92,
  y: 32,
  width: 7,
  height: 8,
  rx: 1,
  fill: "#F64B39",
  stroke: "none"
}));

function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041E\u0444\u0438\u0441\u043D\u043E\u0435 \u0437\u0434\u0430\u043D\u0438\u0435") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.02384fa425372411a2ac82e381cc0f21.svg";
export { ForwardRef as ReactComponent };